export default function inView({ x, y, screen: { w, h } }) {
  return x >= 0 && x <= w && y >= 0 && y <= h
}
